import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, HostListener, Inject } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  animations: [
    trigger('menuAnimation', [
      state('hidden', style({
        opacity: 0,
        transform: 'scale(0.95)',
      })),
      state('visible', style({
        opacity: 1,
        transform: 'scale(1)',
      })),
      transition('hidden => visible', animate('100ms ease-out')),
      transition('visible => hidden', animate('100ms ease-in')),
    ]),
  ],
})
export class HeaderComponent {
  showMenu: boolean = false;

  constructor(
    private elementRef: ElementRef,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
  ) {}

  @HostListener('document:pointerdown', ['$event.target'])
  onDocumentPointerDown(target: EventTarget | null) {
    if (target instanceof Node && !this.elementRef.nativeElement.contains(target)) {
      this.showMenu = false;
    }
  }

  toggleMenu(): void {
    this.showMenu = !this.showMenu;
  }

  async signOut(): Promise<void> {
    await this.oktaAuth.signOut();
  }
}
